import { Icon, Label } from 'semantic-ui-react';
import { getHazardIconPath } from 'utils';
import moment from 'moment';
import { defaultDateFormatJustDate } from 'Dates';

export const renderSuggestionAddition = (obj: any, t: any) => (
  <div>
    {obj.state && (
      <Label size="tiny">
        {t('chemical.product.details.page.chemical.container.state.input.label')}
        <Label.Detail>{t(obj.state.name)}</Label.Detail>
      </Label>
    )}
    {obj.supplier && (
      <Label size="tiny">
        {t('chemical.product.details.page.chemical.container.supplier.input.label')}
        <Label.Detail>{obj.supplier.name}</Label.Detail>
      </Label>
    )}
    {obj.purity && (
      <Label size="tiny">
        {t('chemical.product.details.page.chemical.other.container.purity.input.label')}
        <Label.Detail>{obj.purity}</Label.Detail>
      </Label>
    )}
    <>
      {obj.hazards &&
        obj.hazards.map((h: any) => (
          <img
            src={getHazardIconPath(h.id)}
            key={obj.is + '-' + h.id}
            height="20"
            className="hazardCell"
            style={{ verticalAlign: 'middle' }}
            alt="hazard"
          />
        ))}
    </>
    {obj.validateDte && (
      <Label size="tiny" basic color="green" style={{ float: 'right' }}>
        <Icon name="check" />
        {t('chemical.product.details.page.validate.inf.container.title.with.date', {
          date: moment(obj.validateDte).format(defaultDateFormatJustDate),
        })}
      </Label>
    )}
  </div>
);
